export default __webpack_public_path__ + "static/visual-studio-c8eeccc131a4d93b02cf05450b3b1be2.svg";